import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { ssoAction } from '../../../state/actions/creators/sso.actioncreator';
import { Flex } from '../../shared/components/basic';

class Sso extends PureComponent {
  componentDidMount() {
    const { match, ssoAction } = this.props;
    const { params } = match;
    const { ssotoken } = params;
    ssoAction(ssotoken);
  }

  render() {
    const { status } = this.props;
    return (
      <Flex width={[1, 480]} margin="auto" py={6} alignItems="center" justifyContent="center">
        { status ? <Loader height={180} width={180} type="Oval" color="#444963" /> : <FontAwesomeIcon icon={faExclamationTriangle} size="6x" />}
      </Flex>
    );
  }
}


Sso.propTypes = {
  match: PropTypes.string.isRequired,
  ssoAction: PropTypes.object,
};
Sso.defaultProps = {
  ssoAction: 'test',
};

const mapStateToProps = state => ({
  status: state.pending_requests.SSO,
});

const mapDispatchToProps = dispatch => ({
  ssoAction: token => dispatch(ssoAction(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sso);
